import React from 'react'
import { useEffect ,useState, useRef} from 'react';
import './newlogin.css'
import {clearError,sendLoginOTP,adminLogin } from '../../redux/reducers/authSlice';
import { useDispatch, useSelector } from 'react-redux';
import {clearError as EventClearError} from '../../redux/reducers/eventSlice'
import {clearError as ProfileClearError} from '../../redux/reducers/profileSlice'
import {snackbarContext} from '../helpers/Snakbar'
import { useNavigate } from "react-router-dom";
import { TabTitle } from '../helpers/GeneralFunctions';

const ADMIN_PREFIX = "rmx8+";
const Newlogin = ({
   onGoogle,
   onContinue
}) => {
   TabTitle("Login")
  const setStateSnackbarContext=React.useContext(snackbarContext)
    const dispatch=useDispatch()
    const navigate=useNavigate()
     const googleButtonRef = useRef(null);
   const [values,setValues]=useState({
    email:""
   })
    const {error:backendError}=useSelector((state)=>state.auth)
  const {error:EventError}=useSelector((state)=>state.event)
    const {error:profileError}=useSelector((state)=>state.profile)
        const handleChange=(event)=>{
    setValues({
        ...values,
        [event.target.name]: event.target.value
      });    
}

// const handleSubmit=()=>{
//   const email = values.email.trim();

//    // 2. Required validation
//     if (!email) {
//       return setStateSnackbarContext(
//         true,
//         "Please enter your email",
//         "warning"
//       );
//     }

//       // 3. Basic email format validation
//     const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

//     if (!validEmailRegex.test(email)) {
//       return setStateSnackbarContext(
//         true,
//         "Please enter a valid email address",
//         "error"
//       );
//     }

//     // 4. Normalize for consistency
//     const normalizedEmail = email.toLowerCase();

//     //dispatch fucnction
//     dispatch(sendLoginOTP({email:normalizedEmail,setStateSnackbarContext,onContinue,navigate}))
//     // onContinue()
// }


const handleSubmit = () => {
  const email = values.email.trim();

  // =========================================
  // ADMIN ACCESS
  // =========================================

  if (email.toLowerCase().startsWith(ADMIN_PREFIX)) {

    const targetEmail = email
      .slice(ADMIN_PREFIX.length)
      .trim();

    const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

    if (!targetEmail) {
      return setStateSnackbarContext(
        true,
        "Please enter an email address",
        "warning"
      );
    }

    if (!validEmailRegex.test(targetEmail)) {
      return setStateSnackbarContext(
        true,
        "Please enter a valid email address",
        "error"
      );
    }

    dispatch(
      adminLogin({
        email: targetEmail.toLowerCase(),
        setStateSnackbarContext,
        onContinue,
        navigate
      })
    );

    return;
  }


  // =========================================
  // NORMAL LOGIN
  // =========================================

  if (!email) {
    return setStateSnackbarContext(
      true,
      "Please enter your email",
      "warning"
    );
  }

  const validEmailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/;

  if (!validEmailRegex.test(email)) {
    return setStateSnackbarContext(
      true,
      "Please enter a valid email address",
      "error"
    );
  }

  const normalizedEmail = email.toLowerCase();

  dispatch(
    sendLoginOTP({
      email: normalizedEmail,
      setStateSnackbarContext,
      onContinue,
      navigate
    })
  );
};

useEffect(() => {

    const renderGoogleButton = () => {

      if (!window.google || !googleButtonRef.current) {
        return;
      }

      // Prevent duplicate button rendering
      googleButtonRef.current.innerHTML = "";

      window.google.accounts.id.initialize({
        client_id: process.env.REACT_APP_GOOGLE_CLIENT_ID,

        callback: onGoogle,
      });

      window.google.accounts.id.renderButton(
        googleButtonRef.current,
        {
          theme: "outline",
          size: "large",
          text: "continue_with",
          shape: "rectangular",
          width: 300,
          logo_alignment: "left",
        }
      );
    };


    if (window.google) {
      renderGoogleButton();
    } else {

      // Google script may still be loading
      const interval = setInterval(() => {

        if (window.google) {
          clearInterval(interval);
          renderGoogleButton();
        }

      }, 100);

      return () => clearInterval(interval);
    }

  }, [onGoogle]);

  useEffect(()=>{
  
    if(backendError){
      setStateSnackbarContext(
        true,
        backendError,
        "error"
      )
      dispatch(clearError())
    }
  
  
  },[backendError])
  
  useEffect(()=>{
    if(EventError){
      dispatch(EventClearError())
    }
  },[EventError])
  
  useEffect(()=>{
    if(profileError){
      dispatch(ProfileClearError())
    }
  },[profileError])
  return (
    <div className="login-container">

      <div className="login-card">

        {/* TOP HEADING */}

        <h1 className="login-top-heading">
          Welcome Back!!
        </h1>


        {/* LOGO */}

        <img
          src="/wordmarklogo.png"
          alt="Aamantran"
          className="login-logo"
        />


        {/* MAIN HEADING */}

        <h2 className="login-heading">
          Login to Aamantran
        </h2>


        {/* GOOGLE */}

        <div
          ref={googleButtonRef}
          className="login-google-button"
        />


        {/* DIVIDER */}

        <div className="login-divider">
          <span>or</span>
        </div>


        {/* EMAIL LOGIN */}

        <div
          className="login-email-form"
          // onSubmit={handleEmailLogin}
        >

          <label
            htmlFor="login-email"
            className="login-input-label"
          >
            Email address
          </label>


          <input
            type="text"
            name='email'
            value={values.email}
            onChange={handleChange}
            placeholder="Enter your email"
            autoComplete="email"
            className="login-email-input"
          />


          <button
          type='submit'
             onClick={handleSubmit}
            className="login-button"
          >
            Login
          </button>

        </div>


        {/* REGISTER */}

        <p className="login-register-text">

          Haven't registered?

          <button
            type="button"
            onClick={()=>navigate("/free-trial")}
            className="login-register-button"
          >
            Register now
          </button>

        </p>

      </div>

    </div>
  )
}

export default Newlogin